export default "__VITE_ASSET__Cmx0q_Uj__"